import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import fastMemoize from 'fast-memoize';
import React, { useMemo, useContext, useState, createContext } from 'react';
import { useSafeThemeUI } from '../theme-provider/use-theme-ui.esm.js';

var defaultPrefix = 'id';
var generateId = function generateId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPrefix;
  return process.env.NODE_ENV === 'test' ? "".concat(prefix) : "".concat(prefix, "-").concat(Math.random().toString(32).substr(2, 6));
};
var Context = /*#__PURE__*/createContext(generateId);
var getIdGenerator = fastMemoize(function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var count = {};
  return function () {
    var localPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPrefix;
    var nextVal = 0;
    if (localPrefix in count) {
      nextVal = ++count[localPrefix];
    } else {
      count[localPrefix] = nextVal;
    }
    return "".concat(prefix, "-").concat(localPrefix).concat(process.env.NODE_ENV === 'test' ? '' : '-' + nextVal);
  };
});
function IdProvider(_ref) {
  var _ref2;
  var children = _ref.children,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
  var theme = useSafeThemeUI();
  var _prefix = (_ref2 = prefix || theme.contextPath || theme.contextId || '') === null || _ref2 === void 0 ? void 0 : _ref2.toLowerCase().replaceAll('.', '-');
  var genId = useMemo(function () {
    return getIdGenerator(_prefix);
  }, [_prefix]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: genId
  }, children);
}
function useUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPrefix;
  var genId = useContext(Context);
  var _useState = useState(function () {
      return genId(prefix);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  return id;
}

export { IdProvider, generateId, getIdGenerator, useUniqueId };
//# sourceMappingURL=unique-id.esm.js.map
